import { lookupKeys } from './constants';
import { UnitCatalogEntry } from './types';
import { transformDuration } from '../transformers/transform-duration';
import { transformTime } from '../transformers/transform-time';
import { UNIT_CATALOG } from '../unit-catalog';

const findEntryByName = (name: string): UnitCatalogEntry => {
  const entry = UNIT_CATALOG.find((catalogEntry) => catalogEntry.name === name);
  if (!entry) {
    throw new Error(`UNIT_CATALOG missing entry with name "${name}"`);
  }
  return entry;
};

const noneEntry = findEntryByName('none');
const noneLookupKeys = new Set(lookupKeys(noneEntry));

/** Canonical lookup keys derived from UNIT_CATALOG — never hand-author these strings. */
export const CATALOG_UNIT_KEYS = {
  NONE: noneEntry.asciiSymbol.toLowerCase(),
  SEC: findEntryByName('sec').asciiSymbol.toLowerCase(),
  COMPACT_NUMBER: findEntryByName('compact-number').asciiSymbol.toLowerCase(),
} as const;

/** Display-unit targets that coerce missing source units to seconds. */
export const TIME_FAMILY_TARGET_UNITS = UNIT_CATALOG.filter(
  (entry) => entry.transform === transformTime || entry.transform === transformDuration
).flatMap(lookupKeys);

export const TIME_FAMILY_TARGET_UNITS_SET = new Set<string>(TIME_FAMILY_TARGET_UNITS);

export const isMissingUnits = (units?: string): boolean =>
  !units || noneLookupKeys.has(units.toLowerCase());
